import { Coord } from "../../types/Interface";


export default function rotateCoordinate(coord: Coord, pivotCoord: Coord, rotRadian: number): Coord{
	const dx = coord.x - pivotCoord.x;
  const dy = coord.y - pivotCoord.y;

  return {
    x: pivotCoord.x + (dx * Math.cos(rotRadian) - dy * Math.sin(rotRadian)),
    y: pivotCoord.y + (dx * Math.sin(rotRadian) + dy * Math.cos(rotRadian))
  }
}